import { DateWithSession, RenderContext } from '@eventbrite/checkout-fairy-api';
import { utcToZonedTime } from 'date-fns-tz';

export const getSoldOutDates = (
    eventDates: RenderContext['eventDates'],
    timezone: string,
) =>
    eventDates.reduce((acc: Date[], cur: DateWithSession) => {
        if (cur.availability === 'soldOut') {
            acc.push(
                utcToZonedTime(
                    cur.sessions?.[0]?.startDatetime || cur.date,
                    timezone,
                ),
            );
        }
        return acc;
    }, []);
